import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import UserProfile from './UserProfile';
import AllUsers from './AllUsers';
import AddUser from './AddUser';
import Users from './Users'; // Existing Viewer Management component
import './UserManagement.css';

const UserManagement = () => {
  const location = useLocation();
  
  // Get active tab from URL hash or default to 'profile'
  const getActiveTab = () => {
    const hash = location.hash.replace('#', '');
    if (['profile', 'all-users', 'add-user', 'viewer-management'].includes(hash)) {
      return hash;
    }
    return 'profile';
  };

  const [activeTab, setActiveTab] = useState(getActiveTab());

  // Update active tab when hash changes
  useEffect(() => {
    const hash = location.hash.replace('#', '');
    if (['profile', 'all-users', 'add-user', 'viewer-management'].includes(hash)) {
      setActiveTab(hash);
    }
  }, [location.hash]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    window.location.hash = tab;
  };

  return (
    <div className="dashboard-container user-management-page">
      <Sidebar />
      <div className="main-content">
        <div className="wp-admin-header">
          <div className="wp-admin-tabs">
            <button
              className={`wp-admin-tab ${activeTab === 'profile' ? 'active' : ''}`}
              onClick={() => handleTabChange('profile')}
            >
              Profile
            </button>
            <button
              className={`wp-admin-tab ${activeTab === 'all-users' ? 'active' : ''}`}
              onClick={() => handleTabChange('all-users')}
            >
              All Users
            </button>
            <button
              className={`wp-admin-tab ${activeTab === 'add-user' ? 'active' : ''}`}
              onClick={() => handleTabChange('add-user')}
            >
              Add User
            </button>
            <button
              className={`wp-admin-tab ${activeTab === 'viewer-management' ? 'active' : ''}`}
              onClick={() => handleTabChange('viewer-management')}
            >
              Viewer Management
            </button>
          </div>
          <div className="wp-admin-help">
            <button className="wp-admin-help-button">Help</button>
          </div>
        </div>

        <div className="wp-admin-content">
          {activeTab === 'profile' && <UserProfile />}
          {activeTab === 'all-users' && <AllUsers />}
          {activeTab === 'add-user' && <AddUser />}
          {activeTab === 'viewer-management' && <Users />}
        </div>
      </div>
    </div>
  );
};

export default UserManagement;

